var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import SelectSchool from '@/components/select-school/SelectSchool';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch';
import { Guardian } from '@/models/Guardian';
import { excludeRoles } from '@/support/ExcludeRoles';
import { RouteNameEnum } from '@/router/RouteName';
import { RolesEnum } from '@/items/Roles';
let Navigation = class Navigation extends Vue {
    constructor() {
        super(...arguments);
        this.RolesEnum = RolesEnum;
        this.showExtraMenu = false;
        this.breakpointTablet = 1367;
        this.windowWidth = window.innerWidth;
        this.curriculumId = '';
        this.currentUserId = '';
        this.userRole = null;
        this.children = [];
        this.environment = process.env.VUE_APP_BUGSNAG_RELEASE_STAGE || '';
    }
    get exclude() {
        if (this.$store.state && this.$store.state.version) {
            this.navigationItems = excludeRoles[this.$store.state.version].navigationItems;
            this.userRole = this.$store.state.Auth.roles[0].id;
            return !this.navigationItems.scoolUsers.guardians.includes(this.userRole);
        }
    }
    get items() {
        if (this.$route.matched.some((route) => route.name === 'admin')) {
            return this.adminItems;
        }
        return [
            {
                title: this.$t('dashboard.title'),
                link: '/',
                icon: 'home',
                visible: () => {
                    return !this.navigationItems.scoolDesk.includes(this.userRole);
                },
            },
            {
                title: this.$t('idp.title'),
                link: `${this.profileLink}/school-tracker?statuses=highlighted&statuses=busy&statuses=old`,
                icon: 'calculate',
                roles: [RolesEnum.STUDENT],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT);
                },
            },
            {
                title: this.$t('portfolio.title'),
                link: `${this.profileLink}/portfolio`,
                icon: 'perm_media',
                roles: [RolesEnum.STUDENT],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]) && !this.navigationItems.scoolDrive.includes(this.userRole);
                },
            },
            {
                title: this.$t('progress.title'),
                link: `${this.profileLink}/this-is-me`,
                icon: 'face',
                roles: [RolesEnum.STUDENT],
                visible: () => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]);
                },
            },
            {
                title: this.$tc('chat.message', 2),
                link: `${this.profileLink}/messages`,
                icon: 'chat',
                roles: [RolesEnum.STUDENT],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]) && !this.navigationItems.scoolMessenger.includes(this.userRole);
                },
            },
            {
                title: this.$tc('roles.user', 2),
                icon: 'supervised_user_circle',
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.GUARDIAN, RolesEnum.TEACHER],
                items: this.userLinks,
            },
            {
                title: this.$t('navigation.scoolcore'),
                icon: 'school',
                items: [
                    {
                        title: this.$tc('curriculum.title', 2),
                        link: '/curricula/current',
                        icon: 'school',
                    },
                    {
                        title: this.$tc('projects.tabs.subjects'),
                        link: '/subject-overview',
                        icon: 'topic',
                    },
                    {
                        title: this.$tc('subject_label.title', 2),
                        link: '/subject-labels',
                        icon: 'label',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
                    },
                    {
                        title: this.$t('progress.title'),
                        link: '/curricula/skill-sets',
                        icon: 'person_pin',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.BOARD, RolesEnum.TEACHER],
                    },
                    {
                        title: this.$tc('student_plan.template.sidebar'),
                        link: '/plan-templates',
                        icon: 'receipt_long',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.TEACHER, RolesEnum.GUARDIAN],
                    },
                    {
                        title: this.$t('projects.navigation.all'),
                        link: '/projects',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
                        icon: 'cases',
                    },
                    {
                        title: this.$t('projects.navigation.mine'),
                        link: '/my-projects',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
                        icon: 'cases',
                    },
                    {
                        title: this.$tc('library.title'),
                        link: '/curricula',
                        icon: 'library_books',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
                    },
                ],
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.RESELLER],
            },
            // {
            //   title: this.$t('subject.summary.title'),
            //   link: '/goal-summary',
            //   icon: 'table_chart',
            //   roles: [RoleEnum.ADMIN, RoleEnum.TEACHER],
            // },
            {
                title: this.$tc('group.title', 2),
                icon: 'group',
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
                items: [
                    {
                        title: this.$t('group.all'),
                        link: '/groups',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
                        icon: 'group',
                    },
                    {
                        title: this.$t('group.mine'),
                        link: '/groups/mine',
                        roles: [RolesEnum.STUDENT, RolesEnum.TEACHER],
                        icon: 'supervisor_account',
                    },
                ],
            },
            {
                title: this.$t('documents.title'),
                icon: 'folder_open',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, [RolesEnum.MANAGER], RolesEnum.RESELLER, [RolesEnum.SUPERVISOR], [RolesEnum.BOARD], RolesEnum.TEACHER],
                link: '/documents',
            },
            // {
            //   title: this.$tc('projects.navigation.title'),
            //   icon: 'cases',
            //   roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
            //   items: [
            //   ],
            // },
            {
                title: this.$t('stats.title'),
                icon: 'insert_chart_outlined',
                visible: false,
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                items: [
                    {
                        title: this.$t('absence.title'),
                        link: '/absences',
                        icon: 'how_to_reg',
                    },
                ],
            },
            {
                title: this.$t('navigation.scooladmin'),
                icon: 'settings',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.RESELLER],
                items: [
                    {
                        title: this.$tc('school.myschool', 1),
                        link: `/school-settings/${this.schoolId}`,
                        icon: 'domain',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN],
                    },
                    {
                        title: this.$tc('level.title', 2),
                        link: '/levels',
                        icon: 'format_list_numbered',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD],
                    },
                    {
                        title: this.$tc('year.title', 2),
                        link: '/years',
                        icon: 'today',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD],
                    },
                ],
            },
            {
                title: this.$t('group.mine'),
                link: '/groups/mine',
                roles: [RolesEnum.STUDENT, RolesEnum.TEACHER],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]);
                },
                icon: 'supervisor_account',
            },
            {
                title: this.$t('navigation.roster'),
                icon: 'view_agenda',
                roles: [RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER, RolesEnum.STUDENT],
                link: `/roster/${this.$store.state.Auth.id}`,
                visible: () => this.canViewRoster,
            },
            {
                title: this.$t('school.roster'),
                icon: 'view_agenda',
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD],
                items: [
                    {
                        title: this.$tc('room.title', 2),
                        link: '/rooms',
                        icon: 'meeting_room',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD],
                    },
                    {
                        title: this.$tc('lessonType.title', 2),
                        link: '/lesson-types',
                        icon: 'book',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.BOARD],
                    },
                    {
                        title: this.$t('school.settings'),
                        link: '/roster/settings',
                        icon: 'settings',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                    },
                    {
                        title: this.$t('school.templates'),
                        link: '/roster/templates',
                        icon: 'grid_on',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                    },
                    {
                        title: this.$t('school.management'),
                        link: '/roster/management',
                        icon: 'people',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                    },
                ],
                visible: this.canViewRoster,
            },
            {
                title: this.$tc('help.title', 2),
                link: this.helpLink,
                external: true,
                icon: 'info',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.SUPERVISOR, RolesEnum.BOARD, RolesEnum.TEACHER],
            },
            {
                title: this.$tc('feature.title', 2),
                link: 'https://www.mijnleerlijn.nl/updates/',
                external: true,
                icon: 'new_releases',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
            },
            {
                title: this.$tc('logs.title', 1),
                link: '/logs',
                icon: 'view_headline',
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER],
            },
            {
                title: 'Admin',
                link: `/admin`,
                icon: 'admin_panel_settings',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
                visible: () => {
                    return this.$store.state.Auth && this.$store.state.Auth.global_id;
                },
            },
        ];
    }
    get basicTeacherItems() {
        return [
            {
                title: this.$t('dashboard.title'),
                link: '/',
                icon: 'home',
                visible: () => {
                    return !this.navigationItems.scoolDesk.includes(this.userRole);
                },
            },
            {
                title: this.$tc('curriculum.title', 2),
                link: '/curricula/current',
                icon: 'school',
            },
            {
                title: this.$t('group.mine'),
                link: '/groups/mine',
                roles: [RolesEnum.STUDENT, RolesEnum.TEACHER],
                icon: 'supervisor_account',
            },
        ];
    }
    get extraTeacherItems() {
        if (this.$route.matched.some((route) => route.name === 'admin')) {
            return this.adminItems;
        }
        return [
            {
                title: this.$tc('projects.tabs.subjects'),
                link: '/subject-overview',
                icon: 'topic',
            },
            {
                title: this.$t('group.all'),
                link: '/groups',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
                icon: 'group',
            },
            {
                title: this.$t('documents.title'),
                icon: 'folder_open',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, [RolesEnum.MANAGER], RolesEnum.RESELLER, [RolesEnum.SUPERVISOR], [RolesEnum.BOARD], RolesEnum.TEACHER],
                link: '/documents',
            },
            {
                title: this.$t('idp.title'),
                link: `${this.profileLink}/school-tracker?statuses=highlighted&statuses=busy&statuses=old`,
                icon: 'calculate',
                roles: [RolesEnum.STUDENT],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT);
                },
            },
            {
                title: this.$t('portfolio.title'),
                link: `${this.profileLink}/portfolio`,
                icon: 'perm_media',
                roles: [RolesEnum.STUDENT],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]) && !this.navigationItems.scoolDrive.includes(this.userRole);
                },
            },
            {
                title: this.$t('progress.title'),
                link: `${this.profileLink}/this-is-me`,
                icon: 'face',
                roles: [RolesEnum.STUDENT],
                visible: () => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]);
                },
            },
            {
                title: this.$tc('chat.message', 2),
                link: `${this.profileLink}/messages`,
                icon: 'chat',
                roles: [RolesEnum.STUDENT],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]) && !this.navigationItems.scoolMessenger.includes(this.userRole);
                },
            },
            {
                title: this.$tc('roles.user', 2),
                icon: 'supervised_user_circle',
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.GUARDIAN, RolesEnum.TEACHER],
                items: this.userLinks,
            },
            {
                title: this.$t('MijnSjablonen'),
                icon: 'school',
                items: [
                    {
                        title: this.$tc('subject_label.title', 2),
                        link: '/subject-labels',
                        icon: 'label',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
                    },
                    {
                        title: this.$t('progress.title'),
                        link: '/curricula/skill-sets',
                        icon: 'person_pin',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.BOARD, RolesEnum.TEACHER],
                    },
                    {
                        title: this.$tc('student_plan.template.sidebar'),
                        link: '/plan-templates',
                        icon: 'receipt_long',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.TEACHER, RolesEnum.GUARDIAN],
                    },
                    {
                        title: this.$t('projects.navigation.all'),
                        link: '/projects',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
                        icon: 'cases',
                    },
                    {
                        title: this.$t('projects.navigation.mine'),
                        link: '/my-projects',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
                        icon: 'cases',
                    },
                    {
                        title: this.$tc('library.title'),
                        link: '/curricula',
                        icon: 'library_books',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
                    },
                ],
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.RESELLER],
            },
            // {
            //   title: this.$t('subject.summary.title'),
            //   link: '/goal-summary',
            //   icon: 'table_chart',
            //   roles: [RoleEnum.ADMIN, RoleEnum.TEACHER],
            // },
            // {
            //   title: this.$tc('group.title', 2),
            //   icon: 'group',
            //   roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
            //   items: [
            //     {
            //       title: this.$t('group.all'),
            //       link: '/groups',
            //       roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
            //       icon: 'group',
            //     },
            //     {
            //       title: this.$t('group.mine'),
            //       link: '/groups/mine',
            //       roles: [RolesEnum.STUDENT, RolesEnum.TEACHER],
            //       icon: 'supervisor_account',
            //     },
            //   ],
            // },
            // {
            //   title: this.$tc('projects.navigation.title'),
            //   icon: 'cases',
            //   roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
            //   items: [
            //   ],
            // },
            {
                title: this.$t('stats.title'),
                icon: 'insert_chart_outlined',
                visible: false,
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                items: [
                    {
                        title: this.$t('absence.title'),
                        link: '/absences',
                        icon: 'how_to_reg',
                    },
                ],
            },
            {
                title: this.$t('navigation.scooladmin'),
                icon: 'settings',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN,],
                items: [
                    {
                        title: this.$tc('school.myschool', 1),
                        link: `/school-settings/${this.schoolId}`,
                        icon: 'domain',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN],
                    },
                    {
                        title: this.$tc('level.title', 2),
                        link: '/levels',
                        icon: 'format_list_numbered',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER],
                    },
                    {
                        title: this.$tc('year.title', 2),
                        link: '/years',
                        icon: 'today',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER],
                    },
                ],
            },
            {
                title: this.$t('group.mine'),
                link: '/groups/mine',
                roles: [RolesEnum.STUDENT, RolesEnum.TEACHER],
                visible: (item) => {
                    return this.user.hasRole(RolesEnum.STUDENT) && !this.user.hasRole([RolesEnum.ROOT]);
                },
                icon: 'supervisor_account',
            },
            {
                title: this.$t('navigation.roster'),
                icon: 'view_agenda',
                roles: [RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER, RolesEnum.STUDENT],
                link: `/roster/${this.$store.state.Auth.id}`,
                visible: () => this.canViewRoster,
            },
            {
                title: this.$t('school.roster'),
                icon: 'view_agenda',
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD],
                items: [
                    {
                        title: this.$tc('room.title', 2),
                        link: '/rooms',
                        icon: 'meeting_room',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.BOARD],
                    },
                    {
                        title: this.$tc('lessonType.title', 2),
                        link: '/lesson-types',
                        icon: 'book',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.BOARD],
                    },
                    {
                        title: this.$t('school.settings'),
                        link: '/roster/settings',
                        icon: 'settings',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                    },
                    {
                        title: this.$t('school.templates'),
                        link: '/roster/templates',
                        icon: 'grid_on',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                    },
                    {
                        title: this.$t('school.management'),
                        link: '/roster/management',
                        icon: 'people',
                        roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
                    },
                ],
                visible: this.canViewRoster,
            },
            {
                title: this.$tc('help.title', 2),
                link: this.helpLink,
                external: true,
                icon: 'info',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.SUPERVISOR, RolesEnum.BOARD, RolesEnum.TEACHER],
            },
            {
                title: this.$tc('feature.title', 2),
                link: 'https://www.mijnleerlijn.nl/updates/',
                external: true,
                icon: 'new_releases',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.TEACHER],
            },
            {
                title: this.$tc('logs.title', 1),
                link: '/logs',
                icon: 'view_headline',
                roles: [RolesEnum.ROOT, RolesEnum.RESELLER],
            },
            {
                title: 'Admin',
                link: `/admin`,
                icon: 'admin_panel_settings',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
                visible: () => {
                    return this.$store.state.Auth && this.$store.state.Auth.global_id;
                },
            },
        ];
    }
    get locale() {
        const localeSetting = this.$store.state.settings.find((setting) => {
            return setting.key === 'locale';
        });
        let lang = 'nl';
        if (localeSetting && localeSetting.value) {
            lang = localeSetting.value.toLowerCase();
            if (localeSetting.value.includes('_')) {
                lang = localeSetting.value.split('_')[1].toLowerCase();
            }
        }
        return lang;
    }
    get userLinks() {
        const links = [];
        if (this.children.length) {
            this.children.forEach((child) => {
                links.push({
                    title: child.user.name || '',
                    link: this.getChildLink(child),
                    icon: 'school',
                    roles: [RolesEnum.GUARDIAN],
                });
            });
        }
        links.push({
            title: this.$tc('roles.student', 2),
            link: '/students',
            icon: 'school',
            roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
        });
        links.push({
            title: this.$tc('roles.guardian', 2),
            link: '/guardians',
            icon: 'accessibility',
            roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
            visible: () => {
                return !this.navigationItems.scoolUsers.guardians.includes(this.userRole);
            },
        });
        links.push({
            title: this.$tc('roles.teacher', 2),
            link: '/teachers',
            icon: 'assignment_ind',
            roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN, RolesEnum.TEACHER],
        });
        links.push({
            title: this.$tc('roles.specialist', 2),
            link: '/specialists',
            icon: 'developer_board',
            roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
        });
        links.push({
            title: this.$tc('roles.administrator', 2),
            link: '/administrators',
            icon: 'vpn_key',
            roles: [RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.ADMIN],
        });
        links.push({
            title: this.$tc('parnassys.navigation_title', 1),
            link: `/parnassys`,
            icon: 'directions_run',
            roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER, RolesEnum.BOARD],
        });
        // links.push({
        //   title: this.$tc('roles.reseller', 2),
        //   link: '/resellers',
        //   icon: 'share',
        //   roles: [RoleEnum.ROOT, RoleEnum.ADMIN],
        //   visible: () => {
        //     return !this.navigationItems.scoolUsers.resellers.includes(this.userRole);
        //   }
        // });
        return links;
    }
    get drawerState() {
        return this.$store.state.drawer;
    }
    get miniState() {
        return this.$store.state.miniNav;
    }
    set miniState(value) {
        //
    }
    get user() {
        if (this.$store.state.Auth && this.$store.state.Auth.id !== this.currentUserId) {
            this.currentUserId = this.$store.state.Auth.id;
            if (this.exclude) {
                this.fetchRelationships();
            }
        }
        return this.$store.state.Auth;
    }
    get settings() {
        return this.$store.state.settings;
    }
    get schoolId() {
        let application = window.location.host.split('.')[0];
        if (application.includes('localhost:')) {
            application = 'klavertjevier';
        }
        return application;
    }
    get schoolLink() {
        return `/schools/${this.schoolId}`;
    }
    get helpLink() {
        return `https://www.mijnleerlijn.nl/klantenservice/`;
    }
    get profileLink() {
        if (this.user.roles === undefined) {
            return '';
        }
        switch (this.user.roles[0].id) {
            case RolesEnum.ROOT:
                return `/super-administrators/${this.user.id}`;
            case RolesEnum.ADMIN:
                return `/administrators/${this.user.id}`;
            case RolesEnum.RESELLER:
                return `/resellers/${this.user.id}`;
            case RolesEnum.SUPERVISOR:
                return `/supervisors/${this.user.id}`;
            case RolesEnum.BOARD:
                return `/specialists/${this.user.id}`;
            case RolesEnum.TEACHER:
                return `/teachers/${this.user.id}`;
            case RolesEnum.GUARDIAN:
                return `/guardians/${this.user.id}`;
            case RolesEnum.STUDENT:
                return `/students/${this.user.id}`;
        }
        return '';
    }
    get schoolLogo() {
        const setting = this.$store.getters.getSetting('avatar');
        return setting ? setting.value : '';
    }
    set schoolLogo(value) {
        //
    }
    get schoolLogoMini() {
        const setting = this.$store.getters.getSetting('avatar_small');
        return setting ? setting.value : '';
    }
    set schoolLogoMini(value) {
        //
    }
    get canViewScoolTracker() {
        return this.getGuardianSetting('guardian_can_see_student_scooltracker');
    }
    get canViewThisIsMe() {
        return this.getGuardianSetting('guardian_can_see_student_this_is_me');
    }
    get canViewPortfolio() {
        return this.getGuardianSetting('guardian_can_see_student_portfolio');
    }
    get canViewParnassys() {
        return this.$store.getters.hasBrinNumber;
    }
    get canViewFinished() {
        return this.getGuardianSetting('guardian_can_see_student_finished');
    }
    get canViewProfile() {
        return this.getGuardianSetting('guardian_can_see_student_profile');
    }
    get canViewMessages() {
        return this.getGuardianSetting('guardian_can_use_chat_functions');
    }
    get canViewRoster() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'scool_version';
        });
        if (setting.value !== 3) {
            return false;
        }
        if (this.user.hasRole([RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.ROOT])) {
            return true;
        }
        const hideRosterSetting = this.$store.getters.getSetting('hide_my_roster');
        return !(hideRosterSetting && hideRosterSetting.value);
    }
    // protected get canViewRoster() {
    //   return this.getGuardianSetting('guardian_can_use_chat_roster');
    // }
    get canViewNotes() {
        return this.getGuardianSetting('guardian_can_use_chat_notes');
    }
    get adminItems() {
        const prefix = '/admin';
        return [
            {
                title: 'Admin Dashboard',
                link: `${prefix}`,
                icon: 'space_dashboard',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
            },
            {
                title: this.$tc('users', 2),
                icon: 'groups',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
                items: [
                    {
                        title: this.$tc('users', 2),
                        link: `${prefix}/users`,
                        icon: 'people',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.RESELLER],
                    },
                ],
            },
            {
                title: this.$tc('school.title', 2),
                icon: 'domain',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
                items: [
                    {
                        title: this.$tc('school.title', 2),
                        link: `${prefix}/schools`,
                        icon: 'school',
                        roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
                    },
                ],
            },
            {
                title: 'Terug naar school',
                link: '/',
                icon: 'home',
                roles: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.RESELLER],
            },
        ];
    }
    mounted() {
        if (this.windowWidth < this.breakpointTablet) {
            this.toggleMenuState('mini', true);
        }
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }
    fetchRelationships() {
        new Guardian()
            .include(['relationships'])
            .filter('relationship', 'child')
            .find(this.user.id)
            .then((guardian) => {
            this.children = guardian.relationships;
        });
    }
    handleResize() {
        if (this.windowWidth !== window.innerWidth && window.innerWidth < this.breakpointTablet) {
            this.windowWidth = window.innerWidth;
            this.toggleMenuState('mini', true);
        }
    }
    onStateChanged(value, oldValue) { }
    toggleMenuState(type, forcedState) {
        if (type === 'mini') {
            this.$store.dispatch('toggleMini', forcedState);
        }
        else {
            this.$store.dispatch('toggleDrawer', forcedState);
        }
    }
    displayItem(item) {
        if (item.auth === undefined) {
            return true;
        }
        return false;
    }
    canViewItem(item) {
        return this.validateRole(item) && this.validateVisible(item);
    }
    validateRole(item) {
        return !item.roles || this.user.hasRole(item.roles);
    }
    validateVisible(item) {
        if (item.visible === undefined) {
            return true;
        }
        if (typeof item.visible === 'boolean') {
            return item.visible;
        }
        if (typeof item.visible === 'function') {
            return item.visible(item);
        }
        return false;
    }
    async onLogout() {
        await Promise.all([this.$store.dispatch('setIsLoading', true), this.$store.dispatch('userDeauthenticated'), this.$store.dispatch('setIsStoreInitialized', false)]);
        this.$router.push({ name: RouteNameEnum.LOGIN }).catch(() => {
            /** @see https://www.xspdf.com/resolution/58074007.html */
        });
    }
    userChanged(user) {
        if (user && user.hasRole(RolesEnum.GUARDIAN)) {
            this.fetchRelationships();
        }
    }
    getGuardianSetting(key) {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === key;
        });
        if (!setting) {
            return false;
        }
        // loose check for "0" and "1"
        return setting.value == true;
    }
    getChildLink(child) {
        // User is eigenlijk altijd aan guardian
        const redirectUrl = `/students/${child.user.id}`;
        if (!this.user.isGuardian || this.canViewScoolTracker) {
            return redirectUrl;
        }
        if (this.canViewThisIsMe) {
            return `${redirectUrl}/this-is-me`;
        }
        if (this.canViewPortfolio) {
            return `${redirectUrl}/portfolio`;
        }
        if (this.canViewFinished) {
            return `${redirectUrl}/finished`;
        }
        if (this.canViewProfile) {
            return `${redirectUrl}/profile`;
        }
        if (this.canViewMessages) {
            return `${redirectUrl}/messages`;
        }
        if (this.canViewRoster) {
            return `${redirectUrl}/roster`;
        }
        if (this.canViewNotes) {
            return `${redirectUrl}/notes`;
        }
        return redirectUrl;
    }
};
__decorate([
    Watch('drawerState'),
    Watch('miniState'),
    Watch('user'),
    Watch('schoolLogo'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], Navigation.prototype, "onStateChanged", null);
__decorate([
    Watch('user'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Navigation.prototype, "userChanged", null);
Navigation = __decorate([
    Component({
        components: {
            LanguageSwitch,
            SelectSchool,
        },
    })
], Navigation);
export default Navigation;
